import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MenuItem {
    id: string;
    name: string;
    key: string;
    totalNew: number;
    url: string;
}

interface ChildMenu extends MenuItem {
    order: number;
}

interface ParentMenu extends MenuItem {
    isParent: boolean;
    children: ChildMenu[];
}

type MenuState = {
    menus: ParentMenu[]
}

const initialState: MenuState = {
    menus: []
};

const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        setDataMenus: (state, action: PayloadAction<ParentMenu[]>) => {
            state.menus = action.payload;
        }
    },
});

export const { setDataMenus } = menuSlice.actions;
export default menuSlice.reducer;
